const prefix = '@account';

export const AccountActionTypes = {
  GET_INFO: `${prefix}/GET_INFO`,
  GET_INFO_SUCCEEDED: `${prefix}/GET_INFO_SUCCEEDED`,
  UPDATE_COMPANY: `${prefix}/UPDATE_COMPANY`,
  SET_INFO: `${prefix}/SET_INFO`,
  SET_INFO_SUCCEEDED: `${prefix}/SET_INFO_SUCCEEDED`,
  SET_AVATAR_FILE: `${prefix}/SET_AVATAR_FILE`,
  FETCH_COMPANIES: `${prefix}/FETCH_COMPANIES_REQUEST`,
  FETCH_COMPANIES_SUCCEEDED: `${prefix}/FETCH_COMPANIES_SUCCEEDED`,
  SELECT_COMPANY: `${prefix}/SELECT_COMPANY`,
  CREATE_COMPANY_REQUEST: `${prefix}/CREATE_COMPANY_REQUEST`,
  CREATE_COMPANY_SUCCEEDED: `${prefix}/CREATE_COMPANY_SUCCEEDED`,
  GET_INITIAL_APP_DATA: `${prefix}/GET_INITIAL_APP_DATA`,
  SET_INITIAL_APP_DATA_STATUS: `${prefix}/SET_INITIAL_APP_DATA_STATUS`,
  CHECKOUT_NEW_SUBSCRIPTION: `${prefix}/CHECKOUT_NEW_SUBSCRIPTION`,
  CHANGE_COMPANY_SUBSCRIPTION: `${prefix}/CHANGE_COMPANY_SUBSCRIPTION`,
  OPEN_SELF_SERVE_PORTAL: `${prefix}/OPEN_SELF_SERVE_PORTAL`,
  ACKNOWLEDGE_SUBSCRIRPTION_CHANGES: `${prefix}/ACKNOWLEDGE_SUBSCRIPTION_CHANGES`,
  LOAD_MOTIVATION_SETTINGS_REQUEST: `${prefix}/LOAD_MOTIVATION_SETTINGS`,
  LOAD_MOTIVATION_SETTINGS_SUCCEED: `${prefix}/LOAD_MOTIVATION_SETTINGS_SUCCEED`,
  SET_MOTIVATION_SETTINGS: `${prefix}/SET_MOTIVATION_SETTINGS`,
  DELETE_MOTIVATION_SETTINGS: `${prefix}/DELETE_MOTIVATION_SETTINGS`,
  TOGGLE_IMPERIAL_METRIC: `${prefix}/TOGGLE_IMPERIAL_METRIC`,
  SET_CUSTOM_COLORS: `${prefix}/SET_CUSTOM_COLORS`,
  REMOVE_USER_COLOR: `${prefix}/REMOVE_USER_COLOR`,
  SET_SUBSCRIBE_ERROR: `${prefix}/SET_SUBSCRIBE_ERROR`,
};
